/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'

import { EuiFormRow, EuiFieldText } from '@elastic/eui'

import { FormattedMessage } from '@modules/i18n'
import type { TrafficFilterRule } from '@modules/cloud-api/v1/types'

type Props = {
  rules: TrafficFilterRule[]
  onChange: (rules: TrafficFilterRule[]) => void
  isOptional: boolean
}

const VpceFilterField: React.FunctionComponent<Props> = ({ rules, onChange, isOptional }) => {
  const vpceRule = rules.length > 0 ? rules[0] : { source: '' }

  const onChangeVpceFilter = (value: string) => {
    const updatedRules = [{ source: value }]
    onChange(updatedRules)
  }

  return (
    <EuiFormRow
      label={
        <FormattedMessage
          id='vpceFilterField.label'
          defaultMessage='VPCE filter {isOptional}'
          values={{ isOptional: isOptional ? ' (optional)' : '' }}
        />
      }
      helpText={
        <FormattedMessage
          id='vpceFilterField.helpText'
          defaultMessage='Allowlist specific Virtual Private Connection Endpoint (VPCE).'
        />
      }
    >
      <EuiFieldText
        value={vpceRule?.source || ''}
        onChange={(e) => onChangeVpceFilter(e.target.value)}
        fullWidth={true}
      />
    </EuiFormRow>
  )
}

export default VpceFilterField
